import { useMemo } from "react";

import { filterEventsByMonth } from "./DSSCalendar.utils";
import { mockEvents } from "./mockEvents";
import { type DSSCalendarEvent } from "./DSSCalendar.types";

interface UseDSSCalendarEventsResult {
  events: DSSCalendarEvent[];
  isLoading: boolean;
}

export const useDSSCalendarEvents = (
  month: string,
): UseDSSCalendarEventsResult => {
  // v2: replace with useGetApi({ request: "<endpoint>", body: { params: { month, yachtid } } })
  const events = useMemo(
    () => filterEventsByMonth(mockEvents, month),
    [month],
  );

  return {
    events,
    isLoading: false,
  };
};
